// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"594":"about","702":"querybridge","945":"dashboard"}[chunkId] || chunkId) + "." + {"317":"c3f71a04","594":"e199cb3f","702":"ebc3a4cd","945":"fae9dd64"}[chunkId] + ".js";
};